import type { ScheduledCancelNextInstallment } from '../purchase.enum'

export class ScheduleCancelInputDto {
    simulation?: boolean
    scheduledCancelAt: Date | string
    nextInstallment: ScheduledCancelNextInstallment
}

export class ScheduleCancelChargeDto {
    chargeId: string
    dueDate: Date
    currentValue: number
    // valor após o ajuste. null quando a cobrança é cancelada ou fica intacta.
    newValue: number
    action: 'aborted' | 'adjusted' | 'kept' | 'none'
}

export class ScheduleCancelOutputDto {
    simulation: boolean
    scheduledCancelAt: Date
    // o que foi enviado
    nextInstallment: ScheduledCancelNextInstallment
    // o que a api aplicou de fato. pode ser diferente do enviado — nesse caso 'reason' explica
    appliedInstallment: ScheduledCancelNextInstallment
    reason: string
    // dias do período da cobrança realmente usados até o encerramento
    daysUsed: number
    charge: ScheduleCancelChargeDto
}

export class RevokeScheduledCancelOutputDto {
    restored: 'value' | 'charge' | 'none'
    charge: {
        chargeId: string
        dueDate: Date
        value: number
    }
}
